import React, { useState, useCallback } from 'react';
import { ReactComponent as SearchIcon } from '../../assets/icons/search.svg';
import './SearchBar.css';

interface SearchBarProps {
  onSearch: (query: string) => Promise<void>;
  placeholder?: string;
  isLoading?: boolean;
}

const SearchBar: React.FC<SearchBarProps> = ({
  onSearch,
  placeholder = "Rechercher une commande...",
  isLoading = false
}) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSubmit = useCallback(async (e: React.FormEvent) => {
    e.preventDefault();
    await onSearch(searchQuery);
  }, [searchQuery, onSearch]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  return (
    <form className="search-bar" onSubmit={handleSubmit}>
      <div className="search-input-wrapper">
        {isLoading ? (
          <div className="search-loading"></div>
        ) : (
          <SearchIcon className="search-icon" />
        )}
        <input
          type="text"
          value={searchQuery}
          onChange={handleChange}
          placeholder={placeholder}
          className="search-input"
        />
      </div>
    </form>
  );
};

export default SearchBar;